import React from "react";
import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import styles from "./PillSelect.module.css";

/**
 * Single-select pill row (the stitch existing/new toggle, assign-mode
 * buttons). Selected pill gets a blue border + check-circle.
 *
 * @param {{ options: {value: string, label: string, disabled?: boolean}[],
 *           value: string, onChange: (value: string) => void }} props
 */
const PillSelect = ({ options, value, onChange }) => (
  <div className={styles.row} role="group">
    {options?.map((option) => {
      const selected = option?.value === value;
      return (
        <button
          key={option?.value}
          type="button"
          aria-pressed={selected}
          disabled={option?.disabled}
          className={selected ? styles.pillSelected : styles.pill}
          onClick={() => onChange?.(option?.value)}
        >
          {selected && (
            <SvgIcons name="check_circle_filled" className={styles.check} width="18" height="18" />
          )}
          {option?.label}
        </button>
      );
    })}
  </div>
);

export default PillSelect;
